/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProviderInputs */



/**
* | output |
* | --- |
* | "Provider" |
*
* @param {ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const provider = /** @type {((inputs?: ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fournisseur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anbieter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fornitore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поставщик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proveedor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提供者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロバイダー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रदाता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fornecedor")
	return /** @type {LocalizedString} */ ("Provider")
});